import {
  useQuery, UseQueryResult,
} from '@tanstack/react-query';
import { getNotificationSettings } from '../../services/NotificationsService';
import { NotificationSettings } from '../../types/Notifications';

function useGetNotificationSettings(fleetId: string): UseQueryResult<NotificationSettings> {
  return useQuery(
    ['notification-settings', fleetId],
    async (): Promise<NotificationSettings> => getNotificationSettings(fleetId),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
    },
  );
}

export default useGetNotificationSettings;
